// import React, { createContext, useState, useContext, useEffect } from "react";
// import { jwtDecode } from "jwt-decode";

// export const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [token, setToken] = useState(sessionStorage.getItem("token") || null);

//   const login = (jwt) => {
//     sessionStorage.setItem("token", jwt);
//     setToken(jwt);
//     //Get logged in user data.
//     const token = sessionStorage.getItem("token"); // or get from API response
//     if (token) {
//       const decoded = jwtDecode(token);
//       const role =
//         decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
//       sessionStorage.setItem("userrole", role);
//     }
//   };

//   const logout = () => {
//     sessionStorage.removeItem("token");
//     sessionStorage.removeItem("userrole");
//     setToken(null);
//   };

//   return (
//     <AuthContext.Provider value={{ token, login, logout }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => useContext(AuthContext);


import React, { createContext, useState, useContext, useEffect } from "react";
import { jwtDecode } from "jwt-decode";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(sessionStorage.getItem("token") || null);

  const isTokenExpired = (jwt) => {
    if (!jwt) return true;
    try {
      const decoded = jwtDecode(jwt);
      const now = Date.now() / 1000;
      return decoded.exp < now;
    } catch (e) {
      return true;
    }
  };

  const login = (access) => {
    sessionStorage.setItem("token", access);
    setToken(access);

    try {
      const decoded = jwtDecode(access);
      const role =
        decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
      if (role) {
        sessionStorage.setItem("userrole", role);
      }
      const fullname =
        decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname"];
      if (role) {
        sessionStorage.setItem("fullname", fullname);
      }
    } catch (err) {
      console.error("Invalid token", err);
    }
  };

  const logout = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("userrole");
    setToken(null);
  };

  useEffect(() => {
    if (!token) return;

    const decoded = jwtDecode(token);
    const expiresAt = decoded.exp * 1000;
    const now = Date.now();
    const timeout = expiresAt - now;

    if (timeout > 0) {
      const timer = setTimeout(() => {
        logout();
        window.location.href = "/"; 
      }, timeout);
      return () => clearTimeout(timer);
    } else {
      logout();
    }
  }, [token]);

  return (
    <AuthContext.Provider value={{ token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);